import React, { Fragment } from "react";
import { Card, Col, Button } from 'react-bootstrap';
import '../../../../../styles/balanco.scss'

const Fiscal = (props) => {

    const deletar = async (id) => {
        props.deletar(id)
        await props.fetchFiscais()
    }

    const editar = async (id) => {
        props.editar(id)
    }

    const senha = async (id) => {
        props.senha(id)
    }

    return (
        <Fragment>
            <Col>
                <Card className='card-list'>
                    <Card.Body>
                        <Card.Title className="cabeca-card" key={props.key}>{props.fiscal.nome_fiscal} / {props.fiscal.nivel}</Card.Title>
                    </Card.Body>
                    <hr />
                    <Button type="button" className="botao-leis" onClick={() => editar(props.fiscal._id)} variant='primary'>Editar</Button>
                    <Button type="button" className="botao-leis" onClick={() => senha(props.fiscal._id)} variant='warning'>Trocar Senha</Button>
                    <Button type='button' className="botao-leis" onClick={() => deletar(props.fiscal._id)} variant='danger'>Excluir</Button>
                </Card>
            </Col>
        </Fragment >)
}

export default Fiscal;